import Button from '@/components/Button'
import Card from '@/components/Card'
import Layout, { Stack } from '@/components/Layout'
import Text from '@/components/Text'
import { CardNavigationAction, VariantProps } from '@/widgets/SeriesCard'
import { title as titleStyles } from '@/widgets/SeriesCard/style'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import { useTranslation } from 'next-i18next'
import { useMemo } from 'react'

dayjs.extend(relativeTime)

const Standard = ({
  imageUrl,
  navigationAction,
  title,
  numberOfClasses,
  id,
  fluid = false,
  wide = false,
  fixedAspectRatio = true,
  sponsor,
}: Partial<VariantProps>): JSX.Element => {
  const { t } = useTranslation('series')

  const primaryActionButton = useMemo(() => {
    return (
      <div style={{ minWidth: '40%' }} className="ta-r">
        <CardNavigationAction navigationAction={navigationAction}>
          <Button size="sm" theme="primary" label={t('buttonText')} />
        </CardNavigationAction>
      </div>
    )
  }, [navigationAction])

  return (
    <Card
      theme="standard"
      overlay={false}
      shadow
      backgroundImage={imageUrl}
      sponsorLogo={sponsor?.logoUrl ? sponsor.logoUrl : null}
      href={navigationAction?.url}
      fluid={fluid}
      fixedAspectRatio={fixedAspectRatio}
      wide={wide}
      header={
        <Layout>
          <Stack y justifyContent="center">
            <Text
              title={typeof title === 'string' ? title : ''}
              tag="h2"
              weight="lg"
              size="xs"
              responsiveSize={{
                sm: 'sm',
              }}
              className={`${!wide ? `${titleStyles} ellipsis-2L` : ''} mb-xxs fc-dark`}
            >
              {title}
            </Text>
            {wide ? primaryActionButton : null}
          </Stack>
        </Layout>
      }
      footer={
        <Layout>
          <Stack y>
            <Stack x={!wide} y={wide} alignItems="center" justifyContent="flex-end" alignSelf="flex-end">
              {numberOfClasses ? (
                <Text size="xs" weight="sm" className="fc-primary">
                  {numberOfClasses} {t('classes')}
                </Text>
              ) : null}
              {!wide ? primaryActionButton : null}
            </Stack>
          </Stack>
        </Layout>
      }
      data-id={id}
    />
  )
}

export default Standard
